import { getSiteUiCopy } from "@/lib/site-ui-copy";
import { DEFAULT_LANG } from "@/lib/constants";
import type { Lang } from "@/lib/types";

export type BookCallPopupOrigin = {
  centerX: number;
  centerY: number;
  width: number;
  height: number;
  backgroundColor: string;
  color: string;
  borderColor: string;
  borderRadius: string;
  borderStyle: string;
  borderWidth: string;
  boxShadow: string;
  fontFamily: string;
  fontSize: string;
  fontWeight: string;
  letterSpacing: string;
  label: string;
  icon: "arrow" | "calendar" | null;
  iconBackgroundColor: string;
  iconBorderColor: string;
  iconBorderRadius: string;
  iconBorderStyle: string;
  iconBorderWidth: string;
  iconBoxShadow: string;
  iconColor: string;
};

export function bookCallVariantFromElement(
  element: HTMLElement,
): string | undefined {
  const raw = element.dataset.bookCallVariant?.trim();
  return raw || undefined;
}

export function bookCallOriginFromElement(element: HTMLElement, lang: Lang = DEFAULT_LANG): BookCallPopupOrigin {
  const rect = element.getBoundingClientRect();
  const style = window.getComputedStyle(element);
  const iconElement = element.querySelector<HTMLElement>(".cc-btn__icon-wrap");
  const iconStyle = iconElement ? window.getComputedStyle(iconElement) : null;
  const iconName = element.dataset.bookCallIcon;
  return {
    centerX: rect.left + rect.width / 2,
    centerY: rect.top + rect.height / 2,
    width: Math.max(rect.width, 1),
    height: Math.max(rect.height, 1),
    backgroundColor: style.backgroundColor,
    color: style.color,
    borderColor: style.borderColor,
    borderRadius: style.borderRadius,
    borderStyle: style.borderStyle,
    borderWidth: style.borderWidth,
    boxShadow: style.boxShadow,
    fontFamily: style.fontFamily,
    fontSize: style.fontSize,
    fontWeight: style.fontWeight,
    letterSpacing: style.letterSpacing,
    label:
      element.innerText?.trim() ||
      element.textContent?.trim() ||
      element.getAttribute("aria-label") ||
      getSiteUiCopy(lang).bookCall,
    icon:
      iconName === "calendar" || iconName === "arrow" ? iconName : null,
    iconBackgroundColor: iconStyle?.backgroundColor ?? "#ffffff",
    iconBorderColor: iconStyle?.borderColor ?? "transparent",
    iconBorderRadius: iconStyle?.borderRadius ?? "0px",
    iconBorderStyle: iconStyle?.borderStyle ?? "solid",
    iconBorderWidth: iconStyle?.borderWidth ?? "0px",
    iconBoxShadow: iconStyle?.boxShadow ?? "none",
    iconColor: iconStyle?.color ?? style.color,
  };
}

export function defaultBookCallPopupOrigin(lang: Lang = DEFAULT_LANG): BookCallPopupOrigin {
  // This value is rendered while the popup is dormant and hidden. Keep it
  // identical on the server and on the client's first render; the real trigger
  // geometry replaces it before the popup becomes visible.
  return {
    centerX: 0,
    centerY: 0,
    width: 48,
    height: 48,
    backgroundColor: "#3aafa9",
    color: "#ffffff",
    borderColor: "transparent",
    borderRadius: "9999px",
    borderStyle: "solid",
    borderWidth: "1px",
    boxShadow: "none",
    fontFamily: "inherit",
    fontSize: "0.875rem",
    fontWeight: "600",
    letterSpacing: "normal",
    label: getSiteUiCopy(lang).bookCall,
    icon: null,
    iconBackgroundColor: "#ffffff",
    iconBorderColor: "transparent",
    iconBorderRadius: "0px",
    iconBorderStyle: "solid",
    iconBorderWidth: "0px",
    iconBoxShadow: "none",
    iconColor: "#2d8f8a",
  };
}
